import { Link } from "@fluentui/react/lib/Link";

import { useSmallUrlValueStyles } from "./UseSmallUrlValueStyles";
import { ICommonUrlValueProps } from "../ICommonUrlValueProps";

export function SmallUrlValue({ url, label, count }: ICommonUrlValueProps): JSX.Element {
  const styles = useSmallUrlValueStyles();
  return (
    <Link className={styles.link} href={url} target="_blank">
      {`${label.slice(0, 1).toUpperCase()}${count}`}
    </Link>
  );
}
